import {useTypography} from '../../../hooks/typography';

import {INPUT_SIZE, typographyProps} from './constants';

export function useInputTextCls(inputSize: INPUT_SIZE) {
    const [largeInputCls, mediumInputCls, smallInputCls] = useTypography(typographyProps);

    switch (inputSize) {
    case INPUT_SIZE.LARGE:
        return largeInputCls;
    case INPUT_SIZE.MEDIUM:
        return mediumInputCls;
    case INPUT_SIZE.SMALL:
        return smallInputCls;
    }
}
